import { toast } from 'react-toastify'

import { createAxiosInstance, uploadMaxSize } from '../utils/helpers'
import { API_URL } from './index'
import * as types from './types'
import history from '../utils/history'
import { acceptedFiles } from '../utils/helpers'
import { displayMessages, getParameterByName, uploadFiles } from './common'
import moment from 'moment'

export function initReducer() {
	return (dispatch) => {
		dispatch({ type: types.REINICIAR_SOLICITUD_SERVICIO })
	}
}

export function updateInputs(path, value) {
	return (dispatch) => {
		dispatch({ type: types.MODIFICAR_INPUTS_SOLICITUD_SERVICIO, payload: { path, value } });
	}
}

export function displayModalAddServicio(show, title, mode, index) {
	return (dispatch) => {
		if (show) {
			dispatch({ type: types.MOSTRAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO, payload: { show, title, mode, index } })
		} else {
			dispatch({ type: types.OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO })
		}
	}
}

export function addCencoSolicitudServicioItem() {
	return (dispatch) => {
		dispatch({ type: types.ADICIONAR_NUEVO_CENCO_SOLICITUD_SERVICIO })
	}
}

export function removeCencosSolicitudServicioItem() {
	return (dispatch) => {
		dispatch({ type: types.ELIMINAR_CENCOS_SOLICITUD_SERVICIO_ITEM })
	}
}

export function addSolicitudServicioItem() {
	return (dispatch, getState) => {
		const data = getState().creacionsolicitudservicio.getIn(['modalAddServicio', 'data'])
		const errors = []
		if (!data.get('descripcion')) errors.push('La creación de servicios requiere de una descripción')
		if (data.get('cantidad') < 1) errors.push('La creación de servicios requiere que la cantidad sea superior a 0')
		if (data.get('cencos').count() === 0) errors.push('La creación de servicios requiere al menos de un centro de costo')
		if (data.get('cencos').filter(x => x.get('cenco') === null).count() > 0) errors.push('La creación de servicios requiere que todos los centros de costos estén definidos')
		if (data.get('cencos').filter(x => x.get('porcentaje') < 1).count() > 0) errors.push('El porcentaje en los cencos debe ser mayor a 0')
		const sumDist = data.get('cencos').reduce((a, b) => { a += Number(b.get('porcentaje')); return a }, 0)
		if (sumDist !== 100) errors.push('La creación de servicios requiere la suma de distribución entre cencos sea del 100%')

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {
			const fn1 = (d) => d({ type: types.ADICIONAR_NUEVO_ITEM_SOLICITUD_SERVICIO })
			const fn2 = (d) => d({ type: types.OCULTAR_MODAL_AGREGAR_SERVICIO_SOLICITUD_SERVICIO })
			fn1(dispatch)
			fn2(dispatch)
		}
	}
}

export function removeSolicitudServicioItems() {
	return (dispatch) => {
		dispatch({ type: types.ELIMINAR_ITEMS_SOLICITUD_SERVICIO })
	}
}

export function toggleSelectAllSolicitudServicioItems(checked) {
	return (dispatch) => {
		dispatch({ type: types.CONMUTAR_SELECCION_TODOS_ITEMS_SOLICITUD_SERVICIO, payload: checked })
	}
}

export function toggleSelectAllSolicitudServicioFiles(checked) {
	return (dispatch) => {
		dispatch({ type: types.CONMUTAR_SELECCION_TODOS_ITEMS_FILES, payload: checked })
	}
}

export function uploadFile(file) {
	return (dispatch) => {
		const fileType = acceptedFiles.filter(x => x.type === file.type)
		let icon = '_blank.png';	
		if (fileType.length === 1) {
			icon = fileType[0].icon
		}
		const fn0 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_SERVICIO, payload: { path: 'modalAddFile.data.nombre', value: file.name } })
		fn0(dispatch)
		const fn1 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_SERVICIO, payload: { path: 'modalAddFile.data.file', value: file, immutable: false } })
		fn1(dispatch)
		const fn2 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_SERVICIO, payload: { path: 'modalAddFile.data.icono', value: icon } })
		fn2(dispatch)
	}
}


export function addSolicitudServicioFile() {
	return (dispatch, getState) => {
		const data = getState().common.getIn(['modalAddFile', 'data'])
		const fn1 = (d) => d({ type: types.ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_SERVICIO, payload: data })
		fn1(dispatch)
	}
}




export function removeSolicitudServicioFiles() {
	return (dispatch) => {
		dispatch({ type: types.ELIMINAR_ARCHIVOS_SOLICITUD_SERVICIO })
	}
}

export function displayModalAddFile(show, title, mode, index) {
	return (dispatch) => {
		if (show) {
			const fn0 = (d) => d(getParameterByName('CLASIFICACION_ARCHIVOS'))
			fn0(dispatch)
			dispatch({ type: types.MOSTRAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO, payload: { show, title, mode, index } })
		} else {
			dispatch({ type: types.OCULTAR_MODAL_AGREGAR_ARCHIVO_SOLICITUD_SERVICIO })
		}
	}
}

export function createSolicitudServicio() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		
		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO, payload: true })
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_GUARDAR_SOLICITUD_SERVICIO, payload: false })
		const fn2 = (d) => d(initReducer())

		fn0(dispatch)
		
		const data = getState().creacionsolicitudservicio

		const errors = validarSolicitud(data)

		if (errors.length) {

			fn1(dispatch)

			return errors.forEach(element => {
				toast.warning(element, {bodyClassName: 'toastify-content toastify-warning'})
			});

		} else {

			const files = data.get('adjuntos')

			axios.post(`${API_URL}/solicitudes/servicios`, data)
			.then(res => {
				const fn3 = () => history.push(window.FOLDER + '/');
				const fn4 = () => toast.success('La solicitud ha sido guardada exitosamente', { bodyClassName: 'toastify-content toastify-success' })
				dispatch(uploadFiles(`/files/${res.data.solicitud.id}`, files, [fn1, fn2, fn3, fn4]))
			})
			.catch(err => {
				console.log(err)
				displayMessages(dispatch, err)
				fn1(dispatch)
			})

		}


	}
}


export function enviarComentario() {
	return (dispatch, getState) => {		
		const guid = getState().creacionsolicitudservicio.getIn(['comentario', 'guid'])
		const comentario = getState().creacionsolicitudservicio.getIn(['comentario', 'texto'])
		const usuario = getState().common.get('user')
		const fn1 = (d) => d({ type: types.ENVIAR_COMENTARIO_SOLICITUD_SERVICIO, payload: {comentario, guid , usuario} })
		fn1(dispatch)
	}
}

export function editarComentario(guid) {
	return (dispatch) => {
		const fn1 = (d) => d({ type: types.EDITAR_COMENTARIO_SOLICITUD_SERVICIO, payload: {guid} })
		fn1(dispatch)
	}
}

export function eliminarComentario(guid) {
	return (dispatch) => {
		const fn1 = (d) => d({ type: types.ELIMINAR_COMENTARIO_SOLICITUD_SERVICIO, payload: { guid } })
		fn1(dispatch)
	}
}






// Shared

function validarSolicitud(data) {

	const errors = [];

	if (data.get('fecha_requerido') && moment().subtract('days', 1).isAfter(data.get('fecha_requerido'))) 
		errors.push('La fecha de entrega no debe ser inferior a la de hoy')

	if (data.get('adjuntos').count() > 0) {

		const size = data.get('adjuntos').reduce((a, b) => { a += b.get('file').size; return a }, 0)
		if (size > uploadMaxSize.value) errors.push(`La capacidad máxima para subir archivos es de de ${uploadMaxSize.unidad}`)

		if (data.get('adjuntos').filter(x => !x.get('clasificacion')).count() > 0) errors.push('Todos los archivos deben tener una clasificación')

	}

	return errors
}


// WEBPACK FOOTER //
// ./src/actions/creacionsolicitudservicio.js